import {apiConstructor} from '../api/ConstructorApi';

let stands = []


//init stands list

function initStand() {
    return new Promise((resolve, reject) => {
        apiConstructor.getStands()
        .then(res => {
            const filterStands = res.data.filter(item => {return item.name.toLowerCase().indexOf("пенал") === -1})
            stands = filterStands;
            resolve(stands)
        })
        .catch(res => {
            reject(false)
        })
    })
}

export {stands, initStand} ;